import { render, staticRenderFns } from "./premiumBarClock.vue?vue&type=template&id=4df03124&scoped=true"
import script from "./premiumBarClock.vue?vue&type=script&scoped=true&lang=js"
export * from "./premiumBarClock.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./premiumBarClock.vue?vue&type=style&index=0&id=4df03124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df03124",
  null
  
)

export default component.exports